module.exports = __webpack_public_path__ + "files/a76cd393753cc3c9bb18e085aa40df8f.png";